// Icons
import { appAddUserIcon } from './../svg/add-user';
import { appAngleRightIcon } from './../svg/angle-right';
import { appBackIcon } from './../svg/back';
import { appBackBlueIcon } from './../svg/back-blue';
import { appCheckCircleIcon } from './../svg/check-circle';
import { appDeleteUserIcon } from './../svg/delete-user';
import { appDeleteUserPendingIcon } from './../svg/delete-user-pending';
import { appEditIcon } from './../svg/edit';
import { appErrorCircleIcon } from './../svg/error-circle';
import { appExpandMenuIcon } from './../svg/expand-menu';
import { appExpandMenuWhiteIcon } from './../svg/expand-menu-white';
import { appInfoIcon } from './../svg/info';
import { appLockIcon } from './../svg/lock';
import { appLockWhiteIcon } from './../svg/lock-white';
import { appLogoutIcon } from './../svg/logout';
import { appMailIcon } from './../svg/mail';
import { appMailWhiteIcon } from './../svg/mail-white';
import { appPenIcon } from './../svg/pen';
import { appPhoneIcon } from './../svg/phone';
import { appPhoneWhiteIcon } from './../svg/phone-white';
import { appPlansIcon } from './../svg/plans';
import { appPowerWhiteIcon } from './../svg/power-white';
import { appSearchIcon } from './../svg/search';
import { appSettingsIcon } from './../svg/settings';
import { appSettingsWhiteIcon } from './../svg/settings-white';
import { appSuccessCheckIcon } from './../svg/success-check';
import { appTrashIcon } from './../svg/trash';
import { appUserIcon } from './../svg/user';
import { appUsersIcon } from './../svg/users';

export default [
    appAddUserIcon,
    appAngleRightIcon,
    appBackIcon,
    appBackBlueIcon,
    appCheckCircleIcon,
    appDeleteUserIcon,
    appDeleteUserPendingIcon,
    appEditIcon,
    appErrorCircleIcon,
    appExpandMenuIcon,
    appExpandMenuWhiteIcon,
    appInfoIcon,
    appLockIcon,
    appLockWhiteIcon,
    appLogoutIcon,
    appMailIcon,
    appMailWhiteIcon,
    appPenIcon,
    appPhoneIcon,
    appPhoneWhiteIcon,
    appPlansIcon,
    appPowerWhiteIcon,
    appSearchIcon,
    appSettingsIcon,
    appSettingsWhiteIcon,
    appSuccessCheckIcon,
    appTrashIcon,
    appUserIcon,
    appUsersIcon
]